import { endOfDay, parse } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

interface CalculateTimeLeftProps {
	endDate?: string;
	timezone?: string;
}

export const calculateTimeLeft = ({ endDate, timezone = 'Etc/UTC' }: CalculateTimeLeftProps) => {
	const timeLeft = { days: '--', hours: '--', minutes: '--', seconds: '--' };
	if (!endDate) return timeLeft;

	const userLocalTime = toZonedTime(new Date(), timezone);
	const parsedEndDate = parse(endDate, 'yyyy-MM-dd', userLocalTime);
	const difference = endOfDay(new Date(parsedEndDate)).getTime() - userLocalTime.getTime();

	if (difference > 0) {
		return {
			days: Math.floor(difference / (1000 * 60 * 60 * 24)),
			hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
			minutes: Math.floor((difference / 1000 / 60) % 60),
			seconds: Math.floor((difference / 1000) % 60),
		};
	}

	return timeLeft;
};
